'use strict';

var Marionette = require('backbone.marionette');

var polyglot = require('../../utilities/polyglot').default;

export default Marionette.View.extend({

  tagName: 'li',
  className: 'group-appointment-list-empty',

  render: function () {
    this.$el.text(polyglot.t('calendar.no_times'));
    return this;
  },

});
